<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Umbrella" class="d-icon d-icon--umbrella" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.714 2.423a5.461 5.461 0 0 1 1.784 3.528A.5.5 0 0 1 11 6.5H6.5V10a.5.5 0 0 0 1 0 .5.5 0 0 1 1 0 1.5 1.5 0 0 1-3 0V6.5H1a.5.5 0 0 1-.498-.549 5.461 5.461 0 0 1 1.784-3.528 5.56 5.56 0 0 1 3.198-1.398L5.486.97a.509.509 0 1 1 1.018 0v.053a5.56 5.56 0 0 1 3.21 1.4ZM1.586 5.5a4.46 4.46 0 0 1 1.368-2.333 4.56 4.56 0 0 1 6.092 0A4.46 4.46 0 0 1 10.414 5.5H1.586Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconUmbrella',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
